<template>

 
  <div :id="paneID" >
    <div class="row items-center text-h5 text-center q-pa-sm bg-primary text-white result-pane-header-row">
      <div class="col-3 print-hide">
        <div class="row">
          <q-btn icon="arrow_back" @click="browserBack" class="q-mr-sm q-pl-sm q-pr-sm"  aria-label="Go back">
            <q-tooltip>Go back to your previous screen</q-tooltip>
          </q-btn>
          <div class="pointer shadow-1 q-pl-xs q-pr-xs" >
            <q-icon  v-svg="getIcon('selectArea')"  size="md"  @click="router.push('/select'), clearMapStyle(), loadDataByID('FLAGS', null)"/>
            <q-tooltip>Go back to enter an area of interest</q-tooltip>
          </div>
        </div>
      </div>
      <div class="col-8">Spotlight: {{ habitatPrettynames[activeHabSpotlight] }}</div>
      <div class="col-1 print-hide">
          <q-btn class="q-mt-xs" icon="print"size="sm" @click.stop="print(paneID, null, 'Habitat Spotlight')" v-if="!printing" aria-label="Print spotlight">
            <q-tooltip>Print this panel to PDF</q-tooltip>
          </q-btn>
          <q-spinner v-else />
      </div>
    </div>
    <div class="row q-mt-sm print-hide justify-center">
      <div class="col-5 q-ma-sm "><HabSpotSelect :width="250" label="Spotlight a Habitat"/></div>
    </div>
    <q-card flat class="q-ma-sm">
      <div class="content-container">
        <div v-if="activeHabSpotlight == 'wetlands'">
          <div>
            <div class="text-uppercase text-bold">Current Extent | By Type</div>
            <q-separator color="black"/>
            <div class="text-caption">We classified wetlands based on whether they are exposed to salt water (Estuarine) or they are inland (Palustrine).​</div>
            <div >
              <div class="row q-mt-md">
                <div class="col-10">
                  <div class="text-uppercase">Estuarine Wetlands</div>
                </div>
                <div class="col-1 items-center self-center bordered pointer"  :class="mapStyleInfo['attr'] == 'CMAX' ? 'mapActive' : ''" @click="mapStyleClick('CMAX')">
                  <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'CMAX'" name="play_arrow"></q-icon>
                  <q-icon  class="self-center q-pb-md" v-else name="star" ></q-icon>
                </div>
                <div class="col-12">
                  <div  v-for="wetlandDataObj, ecoreg in wetlandTotals" class="q-pl-md" >
                    <div v-if="['1', '2'].includes(ecoreg)"><span  class="text-bold">{{ ecos[ecoreg] }}</span> {{  Math.round(wetlandDataObj['estuarine']) }} sq km</div>
                  </div>
                </div>
              </div>

              <div class="row q-mt-md">
                <div class="col-10">
                  <div class="text-uppercase">Palustarine Wetlands</div>
                </div>
                <div class="col-1 items-center self-center bordered pointer"  :class="mapStyleInfo['attr'] == 'CMAX' ? 'mapActive' : ''" @click="mapStyleClick('CMAX')">
                  <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'CMAX'" name="play_arrow"></q-icon>
                  <q-icon  class="self-center q-pb-md" v-else name="star" ></q-icon>
                </div>
                <div class="col-12">
                  <div  v-for="wetlandDataObj, ecoreg in wetlandTotals" class="q-pl-md">
                    <div v-if="['1', '2'].includes(ecoreg)"><span class="text-bold">{{ ecos[ecoreg] }}</span> {{ Math.round(wetlandDataObj['palustarine']) }} sq km</div>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
          
          <div class="q-mt-lg text-uppercase text-bold ">Condition | UVVR</div>
          <q-separator color="black"/>
          <div class="row">
            <div class="col-10 text-caption">UVVR is ratio between vegetated and unvegetated areas within a marsh. It is a known indicator of the overall health of this habitat.</div>
            <div class="col-1 q-mt-sm items-center self-center bordered pointer"  :class="mapStyleInfo['attr'] == 'UVVR' ? 'mapActive' : ''" @click="mapStyleClick('UVVR')">
                  <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'UVVR'" name="play_arrow"></q-icon>
                  <q-icon  class="self-center q-pb-md" v-else name="star" ></q-icon>
            </div>
            <div class="col-12">
              <div  v-for="dataObj, ecoreg in COASTAL_HAB_SPOTLIGHT" class="q-pl-md">
                <div v-for="themeObj, themeName in dataObj"  v-if="['1', '2'].includes(ecoreg)">
        
                  <div v-for="arr, layerName in themeObj" v-if="themeName=='wetlands'">
                    <div v-if="layerName=='wetlandVulnBar'">
                      <div v-for="uvvrObj in arr">
                        <div v-if="uvvrObj['category'][0] == 'Stable'">
                          <span class="text-bold">{{ ecos[ecoreg] }}</span> {{  Math.round(uvvrObj['value'] ) }} % stable wetlands
                        </div>
                      </div> 
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>



          <div class="q-mt-lg text-uppercase text-bold ">Priorities | Opportunities</div>
          <q-separator color="black"/>
          <div class="text-caption text-uppercase text-bold ">Resilient Coastal Sites</div>
          <div class="row">
            <div class="col-10 text-caption underline q-pt-sm">Marsh migration space</div>
            <!-- <div class="col-1 q-mt-sm items-center self-center bordered pointer"  :class="mapStyleInfo['attr'] == 'UVVR' ? 'mapActive' : ''" @click="mapStyleClick('UVVR')">
                  <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'UVVR'" name="play_arrow"></q-icon>
                  <q-icon  class="self-center q-pb-md" v-else name="star" ></q-icon>
            </div> -->
            <div class="col-10">
              <div  v-for="dataObj, ecoreg in COASTAL_HAB_SPOTLIGHT" class="q-pl-md">
                <div v-for="val, themeName in dataObj"  v-if="['1', '2'].includes(ecoreg)">
                  <div v-if="themeName=='abvAvgMigSpace'">
                    <span class="text-bold">{{ ecos[ecoreg] }}</span> {{  Math.round(parseInt(val.toString())/1000000) }} sq km  of migration space with above avg resilience
                  </div>
                </div>
              </div>
            </div>

            <div class="col-1 items-center self-center bordered pointer"  :class="mapStyleInfo['attr'] == 'CRMAX' ? 'mapActive' : ''" @click="mapStyleClick('CRMAX')">
              <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'CRMAX'" name="play_arrow"></q-icon>
              <q-icon  class="self-center q-pb-md" v-else name="star" ></q-icon>
            </div>
          </div>
          <div class="row">
            <div class="col-10 text-caption underline q-pt-sm">Vulnerable Tidal Complex</div>
            <!-- <div class="col-1 q-mt-sm items-center self-center bordered pointer"  :class="mapStyleInfo['attr'] == 'UVVR' ? 'mapActive' : ''" @click="mapStyleClick('UVVR')">
                  <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'UVVR'" name="play_arrow"></q-icon>
                  <q-icon  class="self-center q-pb-md" v-else name="star" ></q-icon>
            </div> -->
            <div class="col-12">
              <div  v-for="dataObj, ecoreg in COASTAL_HAB_SPOTLIGHT" class="q-pl-md">
                <div v-for="val, themeName in dataObj"  v-if="['1', '2'].includes(ecoreg)">
                  <div v-if="themeName=='vulnTidal'">
                    <span class="text-bold">{{ ecos[ecoreg] }}</span> {{  Math.round(parseInt(val.toString())/1000000) }} sq km of vulnerable tidal complex
                  </div>
                </div>
              </div>
            </div>
          </div>
          <q-separator class="q-ma-md q-mt-xl"/>
          <CoastalDataConsiderations groupsToShow="wetlands" />
        </div>

      
        

        <div class="row q-ma-xs" v-if="activeHabSpotlight == 'sav'">
          <div class="text-uppercase text-bold">Current Extent | By Type</div>
          <q-separator color="black"/>
    
          <div >
            <div class="row q-mt-md">
              <div class="col-10">
                <div class="text-uppercase underline">Area of Sub-aquatic Vegetation (SAV)<q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="infoDialogs['PERS'].model = !infoDialogs['PERS'].model" aria-label="Seagrass / SAV data help"/></div>
              </div>
              <div class="col-1 items-center self-center bordered pointer"  :class="mapStyleInfo['attr'] == 'PERS' ? 'mapActive' : ''" @click="mapStyleClick('PERS')">
                <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'PERS'" name="play_arrow"></q-icon>
                <q-icon  class="self-center q-pb-md" v-else name="star" ></q-icon>
              </div>
              <div class="col-12">
                <div  v-for="coastalData, ecoreg in allCoastalData" class="q-pl-md" >
                  <!-- {{  coastalData['sav'] }} -->
                  <div v-if="['1', '2'].includes(ecoreg)">
                    <span  class="text-bold">{{ ecos[ecoreg] }}</span> 
                    {{  Math.round(coastalData['sav']['currentSAVArea']/1000000) }} sq km, of which,
                    {{ coastalData['sav']['savHVHPersistence'] }}% has HIGH or VERY HIGH persistence.
                  </div>
                </div>
              </div>
            </div>

            <div class="row q-mt-md">
              <div class="col-10">
                <div class="text-uppercase underline">Area Recently Surveyed in the ecoregion<q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="infoDialogs['LASTSV'].model = !infoDialogs['LASTSV'].model" aria-label="Seagrass / SAV data help"/></div>
              </div>
              <div class="col-1 items-center self-center bordered pointer"  :class="mapStyleInfo['attr'] == 'LASTSV' ? 'mapActive' : ''" @click="mapStyleClick('LASTSV')">
                <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'LASTSV'" name="play_arrow"></q-icon>
                <q-icon  class="self-center q-pb-md" v-else name="star" ></q-icon>
              </div>
              <div class="col-12">
                <div  v-for="coastalData, ecoreg in allCoastalData" class="q-pl-md" >
                  <div v-if="['1', '2'].includes(ecoreg)">
                    <span  class="text-bold">{{ ecos[ecoreg] }}</span> 
                    {{  arrayFindObjectByProp(coastalData['sav']['savDecadesBar'], 'category', '2020s').value }}% surveyed since 2020

                  </div>
                </div>
              </div>
            </div>
            <q-separator class="q-ma-sm q-mt-xl"/>
            <CoastalDataConsiderations groupsToShow="sav" />
          </div>
        </div>

        <div class="row q-ma-xs" v-if="activeHabSpotlight == 'rocky'">
          <div class="text-uppercase text-bold">Current Extent | By Type</div>
          <q-separator color="black"/>
          <div >
            <div class="row q-mt-md">
              <div class="col-10">
                <div class="text-uppercase underline">Area of rocky intertidal habitat in the ecoregion<q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="infoDialogs['rocky'].model = !infoDialogs['rocky'].model" aria-label="Rocky intertidal data help"/></div>
              </div>
              <div class="col-1 items-center self-center bordered pointer"  :class="mapStyleInfo['attr'] == 'ROC' ? 'mapActive' : ''" @click="mapStyleClick('ROC', 'interpolate')">
                <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'ROC'" name="play_arrow"></q-icon>
                <q-icon  class="self-center q-pb-md" v-else name="star" ></q-icon>
              </div>
              <div class="col-12">
                <div  v-for="coastalData, ecoreg in allCoastalData" class="q-pl-md" >
                  <div v-if="['1', '2'].includes(ecoreg)">
                    <span  class="text-bold">{{ ecos[ecoreg] }}</span> 
                    {{  Math.round(coastalData['rocky']['rockyAllArea']/1000000) }} sq km
                  </div>
                </div>
              </div>
            </div>
            <q-separator class="q-ma-sm q-mt-xl"/>
            <CoastalDataConsiderations groupsToShow="rocky" />
          </div>
        </div>

        <div class="row q-ma-xs" v-if="activeHabSpotlight == 'barrierIslands'">
          <div class="text-uppercase text-bold">Current Extent | By Type</div>
          <q-separator color="black"/>
          <div >
            <div class="row q-mt-md">
              <div class="col-10">
                <div class="text-uppercase underline">Area of coastal barrier islands in the ecoregion<q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="infoDialogs['barrierIslands'].model = !infoDialogs['barrierIslands'].model" aria-label="Barrier island data help"/></div>
              </div>
              <div class="col-1 items-center self-center bordered pointer"  :class="mapStyleInfo['attr'] == 'BARR' ? 'mapActive' : ''" @click="mapStyleClick('BARR', 'interpolate')">
                <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'BARR'" name="play_arrow"></q-icon>
                <q-icon  class="self-center q-pb-md" v-else name="star" ></q-icon>
              </div>
              <div class="col-12">
                <div  v-for="coastalData, ecoreg in allCoastalData" class="q-pl-md" >
                  <div v-if="['1', '2'].includes(ecoreg)">
                    <span  class="text-bold">{{ ecos[ecoreg] }}</span> 
                    {{  Math.round(coastalData['features']['barrierIslandArea']/1000000) }} sq km
                  </div>
                </div>
              </div>
            </div>
            <q-separator class="q-ma-sm q-mt-xl"/>
            <CoastalDataConsiderations groupsToShow="BARR" />
          </div>
        </div>

        <div class="row q-ma-xs" v-if="activeHabSpotlight == 'sand'">
          <div class="text-uppercase text-bold">Current Extent | By Type</div>
          <q-separator color="black"/>
          <div >
            <div class="row q-mt-md">
              <div class="col-10">
                <div class="text-uppercase underline">Area of sand / dunes in the ecoregion<q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="infoDialogs['sand'].model = !infoDialogs['sand'].model" aria-label="Sand data help"/></div>
              </div>
              <div class="col-1 items-center self-center bordered pointer"  :class="mapStyleInfo['attr'] == 'SAND' ? 'mapActive' : ''" @click="mapStyleClick('BARR', 'interpolate')">
                <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'SAND'" name="play_arrow"></q-icon>
                <q-icon  class="self-center q-pb-md" v-else name="star" ></q-icon>
              </div>
              <div class="col-12">
                <div  v-for="coastalData, ecoreg in allCoastalData" class="q-pl-md" >
                  <div v-if="['1', '2'].includes(ecoreg)">
                    <span  class="text-bold">{{ ecos[ecoreg] }}</span> 
                    {{  Math.round(coastalData['sand']['totalSandArea']/1000000) }} sq km
                  </div>
                </div>
              </div>
            </div>
            <q-separator class="q-ma-sm q-mt-xl"/>
            <CoastalDataConsiderations groupsToShow="sand" />
          </div>
        </div>
          
        <div class="row q-ma-xs" v-if="activeHabSpotlight == 'smallIslands'">
          <div class="text-uppercase text-bold">Current Extent | By Type</div>
          <q-separator color="black"/>
          <div >
            <div class="row q-mt-md">
              <div class="col-10">
                <div class="text-uppercase underline">Area of small islands in the ecoregion<q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="infoDialogs['smallIslands'].model = !infoDialogs['smallIslands'].model" aria-label="Small island data help"/></div>
              </div>
              <div class="col-1 items-center self-center bordered pointer"  :class="mapStyleInfo['attr'] == 'SMISL' ? 'mapActive' : ''" @click="mapStyleClick('SMISL', 'interpolate')">
                <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'SMISL'" name="play_arrow"></q-icon>
                <q-icon  class="self-center q-pb-md" v-else name="star" ></q-icon>
              </div>
              <div class="col-12">
                <div  v-for="coastalData, ecoreg in allCoastalData" class="q-pl-md" >
                  <div v-if="['1', '2'].includes(ecoreg)">
                    <span  class="text-bold">{{ ecos[ecoreg] }}</span> 
                    {{  Math.round(coastalData['features']['smallIslandsArea']/1000000) }} sq km
                  </div>
                </div>
              </div>
            </div>
            <q-separator class="q-ma-sm q-mt-xl"/>
            <CoastalDataConsiderations groupsToShow="SMISL" />
          </div>
        </div>

        <div class="row q-ma-xs" v-if="activeHabSpotlight == 'estu'">
          <div class="text-uppercase text-bold">Current Extent | By Type</div>
          <q-separator color="black"/>
          <div >
            <div class="row q-mt-md">
              <div class="col-10">
                <div class="text-uppercase underline">Area of estuaries in the ecoregion<q-btn dense size="xs" flat class="gray q-mb-sm" icon="help_outline" @click="infoDialogs['estu'].model = !infoDialogs['estu'].model" aria-label="Estuary data help"/></div>
              </div>
              <div class="col-1 items-center self-center bordered pointer"  :class="mapStyleInfo['attr'] == 'ESTU' ? 'mapActive' : ''" @click="mapStyleClick('ESTU', 'interpolate')">
                <q-icon class="self-center q-pb-md" size="xs" v-if="mapStyleInfo['attr'] != 'ESTU'" name="play_arrow"></q-icon>
                <q-icon  class="self-center q-pb-md" v-else name="star" ></q-icon>
              </div>
              <div class="col-12">
                <div  v-for="coastalData, ecoreg in allCoastalData" class="q-pl-md" >
                  <div v-if="['1', '2'].includes(ecoreg)">
                    <span  class="text-bold">{{ ecos[ecoreg] }}</span> 
                    {{  Math.round(coastalData['features']['estuaryArea']/1000000) }} sq km
                  </div>
                </div>
              </div>
            </div>
            <q-separator class="q-ma-sm q-mt-xl"/>
            <CoastalDataConsiderations groupsToShow="ESTU" />
          </div>
        </div>
      </div>
    </q-card>
  </div>
          
  <div v-for="(infoObj, name) in infoDialogs" :key="name" >
      <q-dialog v-model="infoObj.model">
          <InfoDialog  :html="infoObj.text" :name="infoObj.pName"/>
      </q-dialog>
  </div>
  <q-dialog v-model="coastalDataConsid">
      <CoastalDataConsiderations/>
  </q-dialog>
</template>
<script setup lang="ts">
import { toRefs, ref, computed, onMounted, onUnmounted } from "vue";
import { useRouter } from 'vue-router';
import { useHelpers } from "../composables/useHelpers"
import { useMapItems } from "../composables/useMapItems"
import { stops } from "../assets/ColorStops.json"
import { mapLayerNames, colorStops, classNames, wetlandBarColors, sandBarColors, wetlandVulnBarColors } from "../assets/CoastalHabitatConfig.json"
import { COASTAL_HAB_SPOTLIGHT } from "../assets/CoastalHabSpotlight.json"
import HabSpotSelect from "./HabSpotSelect.vue";
import StackedBar from "./StackedBar.vue";
import InfoDialog from "./InfoDialog.vue";
import { useSvgIcon } from '../composables/useSvgIcon';
import CoastalDataConsiderations from "./CoastalDataConsiderations.vue";
const { getIcon } = useSvgIcon();
const router = useRouter();
const {  map, activeHabSpotlight, loadDataByID, clearMapStyle, styleMap, setLegend, print, printing, mapStyleInfo, activeLayerID, setDataQuality, ecos } = useMapItems()
const { arrayFindObjectByProp, browserBack } = useHelpers();

const paneID = computed(() =>{
  return activeHabSpotlight.value + "spotlightPane"
})


const habitatPrettynames ={
  "wetlands" : "Wetlands",
  "rocky": "Rocky Intertidal" ,
  "sav" : "Seagrass / SAV",
  "barrierIslands" : "Coastal / Barrier Islands",
  "sand" : "Sand / dunes",
  "smallIslands" : "Small Islands",
  "estu" : "Estuaries"
}

const allCoastalData = computed(() =>{

  return COASTAL_HAB_SPOTLIGHT
})

const wetlandTotals = computed(() =>{
  const totals = {}
  for (const [ecoreg, dataObj] of Object.entries(COASTAL_HAB_SPOTLIGHT)) {
    // console.log(ecoreg)
    totals[ecoreg]  = {'estuarine' : 0, 'palustarine' :0}
    for (const [theme, themeObj] of Object.entries(dataObj)) {
      // console.log(theme)
      if (theme == 'wetlands'){
        for (const [layerName, habObj] of Object.entries(themeObj['wetlandBar']) as [string, { category: string[]; value: number; }[]][]) {
          // console.log(habObj)
          if (habObj['category'][0].includes("Estuarine")){
            totals[ecoreg]['estuarine'] += habObj['m2value']/1000000
          }
          if (habObj['category'][0].includes("Palustrine")){
            totals[ecoreg]['palustarine'] += habObj['m2value']/1000000
          }

        }
      }
    }
  }
  return totals
})


const mapStyleClick = (attr, type='categorical') =>{
    let lyrID
    if (activeLayerID.value.includes("QUALITY")){
        lyrID = activeLayerID.value.replace("_QUALITY", "")
        setDataQuality(false)
        loadDataByID(lyrID, null)
    }
    else{lyrID = activeLayerID.value}

    if (["SAND", "ESTU", "BARR", "SMISL", "ROC", "SEAG"].includes(attr)){
      type = "interpolate"
    }
    styleMap(lyrID, attr, type, colorStops[attr], classNames[attr]), 
    setLegend(mapLayerNames[attr], colorStops[attr], classNames[attr])
}

const layerPrettyNames = {
    "SEABED" : "Seabed Forms",
    "Depth" : "Depth",
    "SEDIM" : "Sediment",
    "HARDB" : "Hard bottom",
    "SLOPE" : "Slope",
    "CMAX": "Most common wetland type",
    "CRMAX" : "Most common coastal resilience class",
    "PERS" : "SAV Persistence",
    "LASTSV" : "Year last surveyed",
    "SAND" : "Sand / Dunes",
    "ESTU" : "Estuaries",
    "SMISL": "Small Islands",
    "ROC" : "Rocky Habitats",
    "BARR" : "Barrier Islands",
    "UVVR" : "Vulnerability: Unvegetated to Vegetated Ratio for Coastal Wetlands"
}

const stopNames = {
    "DEPTH" : {
        "-9": "No Data",
        "0": "<10",
        "10": "10 - 25m",
        "25": "25 - 50m",
        "50": "50 - 75m",
        "75": "75 - 100m",
        "100": "100 - 150m",
        "150": "150 - 200m",
        "200": "200 - 300m",
        "300": "300 - 500m",
        "500": "500 - 2750m",
        "2750": ">2750m"
    },
    "CMAX": {
        "C13": "Palustrine Forested Wetland",
        "C14": "Palustrine Scrub/Shrub Wetland",
        "C15": "Palustrine Emergent Wetland (Persistent)",
        "C16": "Estuarine Forested Wetland",
        "C17": "Estuarine Scrub/Shrub Wetland",
        "C18": "Estuarine Emergent Wetland"
    },

    "UVVR" :{
        "1" : "Stable",
        "2": "Low vulnerability",
        "3": "Medium vulnerability",
        "4": "High vulnerability",
        "5": "Very High Vulnerability"
    },
    "PERS" : {
        "-9" : "No Data",
        "1" : "Very High",
        "2" : "High",
        "3" : "Medium",
        "4" : "Low",
        "5" : "Very Low"
    },
    "LASTSV" :{
        "0" : "No Surveys",
        "2020" : "2020s",
        "2010" : "2010s",
        "2000" : "2000s"
    },
    "SAND":  {
        "0" : "None",
        "1" : "Min",
        "1029570" : "Max"
    },
    "ROC":  {
        "0" : "None",
        "1" : "Min",
        "196899" : "Max"
    },
    "ESTU": {
        "0" : "None",
        "1" : "Min",
        "2698870" : "Max"
    },
    "SMISL": {
        "0" : "None",
        "1" : "Min",
        "1139310" : "Max"
    },
    "BARR": {
        "0" : "None",
        "1" : "Min",
        "2424030" : "Max"

    }
}

const infoDialogs = ref({
    wetlands: {
        pName: "Coastal Marshes",
        model: false,
        text: "More info about the importance of coastal marshes."
    },
    wetlandVuln: {
        pName: "Coastal Marsh Vulnerability",
        model: false,
        text: "More info about the vulnerability of coastal marshes."
    },
    sav: {
        pName: "Submerged aquatic vegetation",
        model: false,
        text: "More info about sav."
    },
    PERS:{
        pName: "Seagrass: Persistence",
        model: false,
        text: "Area estimates of sub-aquatic vegetation that are considered of High of Very High persistence. That means that occur frequently in the same location over time. Note that because of data limitations, not all areas have persistence values."
    },
    LASTSV: {
        pName: "Seagrass: Survey Date",
        model: false,
        text: "Seagrass or SAV data varies from state to state. As a result, it is important to consider when the area was surveyed to determine how confident we are on the estimates above."
    },
    sand: {
        pName: "Sand / dunes",
        model: false,
        text: "This section includes beach and dune habitat within each ecoregion. Estimates are based on the comparison between remote sensing estimates and data of known beach and sandy habitat."
    },
    smallIslands :{
        pName: "Small islands",
        model: false,
        text: "Small islands are islands that have an area of less than 1km2. These important features, when combined with habitat information such as intertidal rocky habitats, may highlight important areas for species breeding in the region.  Data originates from USGS."
    },
    rocky :{
        pName: "Rocky Intertidal",
        model: false,
        text: "Rocky intertidal habitat was estimated as part of TNC's Northeast Habitat Map."
    },

    barrierIslands :{
        pName: "Barrier / Coastal Islands",
        model: false,
        text: "Barrier islands are long and narrow pieces of land that run parallel to the main land. These dynamic systems are important habitats for many migratory species and may also serve as a buffer against erosion. The areas included in this map are the barriers that are considered protected under the Coastal Barrier Resources Act. "
    },
    estu:{
      pName: "Estuaries",
      model: false,
      text: "Estuaries are bodies of water that are found where rivers meet the sea. Waters within these estuaries are considered brackish, a mix of fresh and salty water. They provide important habitats for many species of fish and birds."
    }
})

const coastalDataConsid = ref(false)
onMounted(() => {
  if (activeLayerID.value != 'COASTAL'){
    loadDataByID('COASTAL', null)
  }
})

onUnmounted(() =>{
  clearMapStyle();
})


</script>
<style scoped>
.exp-panel{
    border-top: 1px solid #aeaeae;
    border-left: 1px solid #aeaeae;
    border-right:1px solid #aeaeae;
    background-color: #f7f7f7;
 }
 .bottom-border{
    border-bottom:1px solid #aeaeae !important;
 }
 .result-pane-header-row{
  border-top: 1px solid white;
}
.pointer{
  cursor: pointer;
}
.content-container{
    max-height: calc(100vh - 232px);
    height: calc(100vh - 232px);
    overflow: auto;
}
.mapActive{
    background-color: #1D8177;
}
.bordered{
    border: 1px solid black;
    text-align: center;
    max-height: 18px;
    vertical-align: middle;
    border-radius: 3px;
}
.pointer{
    cursor: pointer;
}
.pointer:hover {
  background-color: #464f4b; /* Change to desired hover background color */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Add shadow effect */
  border-radius: 5px;
}

.pointer:active {
  background-color: #464f4b; /* Change to desired active background color */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Adjust shadow effect */
  border-radius: 5px;
}
</style>